<script setup lang="ts">
import { DropdownMenuRoot } from 'reka-ui'
</script>

<template>
    <DropdownMenuRoot :modal="false">
        <slot />
    </DropdownMenuRoot>
</template>
